import { MutationHandlingServiceV2, NotificationService } from '@akebono/core';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { of } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AutoLotView, mergeSavedLotToAutoLotView } from 'src/app/const';
import { Bid, BidUpdateGQL } from 'src/app/modules/graphql/service/graphql-auto-main-service';
import { isLotTradingClosed } from 'src/app/utils/lot-trading.util';

@Component({
  selector: 'app-lot-participation-button',
  templateUrl: './lot-participation-button.component.html',
  styleUrls: ['./lot-participation-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotParticipationButtonComponent {
  @Input() bid?: Bid;
  @Input() lot?: AutoLotView;
  @Input() hasTranslations?: boolean;
  @Output() actionComplete = new EventEmitter<void>();

  isSubmitting$ = of(false);

  constructor(
    private mhs: MutationHandlingServiceV2,
    private bidUpdateGQL: BidUpdateGQL,
    private notificationService: NotificationService,
  ) {}

  get isTradingClosed(): boolean {
    const lot = this.lot || (this.bid?.lot && mergeSavedLotToAutoLotView(null, this.bid.lot));
    return !!lot && isLotTradingClosed(lot);
  }

  updateParticipation(isAccepted: boolean): void {
    if (!this.bid?.id) {
      return;
    }

    if (isAccepted && this.isTradingClosed) {
      this.notificationService.renderError('NEGOTIATIONS.TRADING_CLOSED');
      return;
    }

    this.isSubmitting$ = this.mhs
      .mutate(this.bidUpdateGQL, {
        input: {
          id: this.bid.id,
          isParticipationAccepted: isAccepted,
        },
      })
      .loading.pipe(finalize(() => this.actionComplete.emit()));
  }
}
